import { iZettleMarket, UserRole, LegalEntityType } from '@izettle/constants';
import { getShowPayPalWidget } from './rest.js';

const readerCountries = [iZettleMarket.BR, iZettleMarket.DE, iZettleMarket.DK, iZettleMarket.ES, iZettleMarket.FI, iZettleMarket.FR, iZettleMarket.GB, iZettleMarket.IT, iZettleMarket.MX, iZettleMarket.NL, iZettleMarket.NO, iZettleMarket.SE];
const advanceCountries = [iZettleMarket.DE, iZettleMarket.DK, iZettleMarket.FI, iZettleMarket.GB, iZettleMarket.NL, iZettleMarket.NO, iZettleMarket.SE];
const accessoryCountries = [iZettleMarket.DE, iZettleMarket.DK, iZettleMarket.FI, iZettleMarket.GB, iZettleMarket.MX, iZettleMarket.NL, iZettleMarket.NO, iZettleMarket.SE];
const planCountries = [iZettleMarket.DE, iZettleMarket.DK, iZettleMarket.FI, iZettleMarket.GB, iZettleMarket.NO, iZettleMarket.SE];
const betaReportsCountries = [iZettleMarket.GB];
/**
 * Converted from
 * https://github.com/iZettle/portal/blob/4bb4710911304d41a1096a1a8f54ecc88a4555ac/app/helpers/application_helper.rb#L93-L124
 */
const getWebComponentProps = _ref => {
  let {
    userData,
    urls,
    isImpersonatedUser,
    webshopUrl,
    portalUrl
  } = _ref;
  const {
    user,
    organization,
    identityProvider,
    businessIdentityProvider,
    features,
    locale
  } = userData;
  const fullName = `${user.firstName} ${user.lastName}`;
  const isOwner = user.userRole === UserRole.Owner;
  const isCompany = organization.legalEntityType === LegalEntityType.Company;
  const isPerson = organization.legalEntityType === LegalEntityType.Person;
  const inCountries = countries => countries.includes(organization.countryId);
  const hasBeta = flag => organization.betaFeatures.includes(flag);
  const hasWebshop = readerCountries.includes(organization.countryId);
  const readerUrl = hasWebshop ? webshopUrl : `${portalUrl}/offers/${organization.fullOrganizationUuid}`;
  const canSubscribeToPlan = !isPerson && inCountries(planCountries);
  const hasBetaReports = hasBeta("NewSalesReport") && hasBeta("ProductReport") && inCountries(betaReportsCountries);
  const isSelzActive = features.find(_ref2 => {
    let {
      name
    } = _ref2;
    return name === "SELZ";
  })?.activated;
  const isSelzEnabled = features.find(_ref3 => {
    let {
      name
    } = _ref3;
    return name === "SELZ";
  })?.enabled;
  const canHaveECom = hasBeta("SelzAvailable") && !isPerson;
  const userCanHaveEcom = canHaveECom && (!hasBeta("SelzMigrationPage") && isSelzEnabled || hasBeta("SelzMigrationPage") && isSelzActive || hasBeta("SelzMigrated"));
  return {
    locale: locale.isoLocale,
    urls,
    "user-name": fullName,
    "user-full-name": fullName,
    "user-image": user.profileImageUrl.replace("[size]", "s"),
    "hide-navigation-header": getShowPayPalWidget(isImpersonatedUser, identityProvider, businessIdentityProvider),
    "card-reader-url": isOwner ? readerUrl : null,
    "user-can-have-staff": isCompany,
    "user-can-have-customers": isCompany && isOwner && hasBeta("Customers"),
    "user-can-have-advance": isCompany && inCountries(advanceCountries),
    "user-can-have-ecommerce": userCanHaveEcom,
    "user-can-buy-accessories": inCountries(accessoryCountries),
    "user-can-have-cash-register": isOwner && (hasBeta("CashRegisterBackOffice") || user.eligibleForCashRegister),
    "user-can-have-gift-cards": hasBeta("GiftCardsRollout"),
    "user-has-beta-reports": hasBetaReports,
    // Can't be converted, requires semi-dynamic translations and further data fetching
    "user-can-subscribe-to-plan": canSubscribeToPlan,
    "user-has-pro-support": "",
    "user-subscription-plan": "",
    "show-forever-local": hasBeta("ForeverLocal") && organization.customerStatus === "ACCEPTED"
  };
};

export { getWebComponentProps };
//# sourceMappingURL=header-props.js.map
